import { useEffect } from "react";
import { useAppTheme } from "../../context/ThemeContext";
import { applyOssHead, OSS_THEME_DARK, OSS_THEME_LIGHT } from "../../lib/oss/head";
import { registerOssServiceWorker } from "../../lib/oss/sw";
import OssInstallPrompt from "./OssInstallPrompt";
import OssOfflineBanner from "./OssOfflineBanner";
import OssUpdateBanner from "./OssUpdateBanner";

/**
 * PWA dell'area OSS: metadati <head> (manifest /oss), service worker /oss-sw.js (scope /oss, solo
 * browser: nelle app native non viene registrato), banner "Aggiorna" e invito all'installazione.
 */
export default function OssPwaShell({ children }) {
  const { effectiveTheme } = useAppTheme();

  useEffect(() => applyOssHead(), []);

  useEffect(() => {
    registerOssServiceWorker();
  }, []);

  useEffect(() => {
    const color = effectiveTheme === "dark" ? OSS_THEME_DARK : OSS_THEME_LIGHT;
    document.head
      .querySelectorAll('meta[name="theme-color"]')
      .forEach((m) => m.setAttribute("content", color));
  }, [effectiveTheme]);

  return (
    <>
      <OssUpdateBanner />
      <OssOfflineBanner />
      {children}
      <OssInstallPrompt />
    </>
  );
}
